var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ContainerWithMenu',[_c('div',{staticClass:"page-content"},[_vm._v(" Users ")])])}
var staticRenderFns = []

export { render, staticRenderFns }